const SearchIcon = ({ onClick, white }) => {
  return (
    <svg
      onClick={onClick}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.563 24.563a.618.618 0 0 0 0-.874l-7.136-7.142a9.958 9.958 0 1 0-.88.88l7.142 7.136a.618.618 0 0 0 .874 0zm-14.56-5.884a8.675 8.675 0 1 1 0-17.35 8.675 8.675 0 0 1 0 17.35z" 
        fill={white? "#fff": "#000"}
      />
      {`${white}`}
    </svg>
  )
}

export default SearchIcon
